// STATUS: draft — needs native-speaker check before live
// German visitor messages (task TR1, docs/modules/languages.md s2). Visitor keys only; missing keys fall back to en-GB.
export const deVisitor = {
    'kiosk.pairing.title': 'Dieses Kiosk einrichten',
    'kiosk.pairing.hint': 'Geben Sie den Code aus dem CloudSign-Portal ein.',
    'kiosk.pairing.go': 'Koppeln',
    'kiosk.pairing.codeLabel': 'Kopplungscode',
    'kiosk.pairing.checking': 'Code wird geprüft…',
    'kiosk.pairing.clear': 'Löschen',
    'kiosk.pairing.back': 'Letzte Ziffer löschen',
    'kiosk.pairing.invalid': 'Dieser Code ist ungültig oder abgelaufen. Bitte fordern Sie einen neuen an.',
    'kiosk.pairing.noNetwork': 'CloudSign konnte nicht erreicht werden. Bitte prüfen Sie das WLAN und versuchen Sie es erneut.',
    'kiosk.common.back': 'Zurück',
    'kiosk.common.next': 'Weiter',
    'kiosk.common.continue': 'Fortfahren',
    'kiosk.common.cancel': 'Abbrechen',
    'kiosk.common.yes': 'Ja',
    'kiosk.common.no': 'Nein',
    'kiosk.welcome.tap': 'Hier tippen, um sich anzumelden oder abzumelden',
    'kiosk.welcome.offline': 'Offline: Anmeldungen werden gespeichert und später übermittelt',
    'kiosk.home.title': 'Was möchten Sie tun?',
    'kiosk.home.signIn': 'Anmelden',
    'kiosk.home.signOut': 'Abmelden',
    'kiosk.home.scan': 'Meinen Ausweis scannen',
    'kiosk.groups.titleIn': 'Als wer melden Sie sich an?',
    'kiosk.groups.titleOut': 'Als wer melden Sie sich ab?',
    'kiosk.groups.hint': 'Wählen Sie die Option, die am besten zu Ihnen passt.',
    'kiosk.groups.repeat': 'Stammmitglieder',
    'kiosk.pin.hint': 'Geben Sie Ihre 4-stellige PIN ein.',
    'kiosk.pin.entered': '{count} von 4 Ziffern eingegeben',
    'kiosk.pin.wrong': 'Diese PIN ist nicht richtig. Bitte versuchen Sie es erneut.',
    'kiosk.pin.locked': 'Zu viele falsche PINs. Die PIN-Eingabe ist für einige Minuten gesperrt. Bitte bitten Sie jemanden um Hilfe.',
    'kiosk.pin.clear': 'Löschen',
    'kiosk.pin.back': 'Letzte Ziffer löschen',
    'kiosk.identify.title': 'Finden Sie Ihren Namen',
    'kiosk.identify.placeholder': 'Geben Sie Ihren Namen ein',
    'kiosk.identify.none': 'Unter diesem Namen wurde niemand gefunden.',
    'kiosk.identify.addSelf': 'Ich stehe nicht auf der Liste',
    'kiosk.addSelf.title': 'Sich selbst hinzufügen',
    'kiosk.name.title': 'Wie heißen Sie?',
    'kiosk.name.label': 'Ihr Name',
    'kiosk.name.fullNameHint': 'Bitte geben Sie Ihren Vor- und Nachnamen an.',
    'kiosk.already.message': 'Sie sind bereits angemeldet. Möchten Sie sich stattdessen abmelden?',
    'kiosk.already.signOut': 'Mich abmelden',
    'kiosk.questions.titleIn': 'Ein paar kurze Fragen',
    'kiosk.questions.titleOut': 'Bevor Sie gehen',
    'kiosk.questions.datePlaceholder': 'YYYY-MM-DD',
    'kiosk.questions.acknowledge': 'Ich habe verstanden',
    'kiosk.questions.hostSearch': 'Geben Sie den Namen der Person ein, die Sie besuchen',
    'kiosk.questions.changeHost': 'Ändern',
    'kiosk.notices.progress': 'Hinweis {n} von {total}',
    'kiosk.notices.accept': 'Ich habe dies gelesen und stimme zu',
    'kiosk.notices.sign': 'Unterschreiben',
    'kiosk.notices.signHere': 'Bitte unterschreiben Sie mit dem Finger.',
    'kiosk.signature.pad': 'Unterschriftenfeld',
    'kiosk.signature.clear': 'Unterschrift löschen',
    'kiosk.signature.captured': 'Unterschrift gespeichert',
    'kiosk.photo.title': 'Foto',
    'kiosk.photo.hint': 'Schauen Sie in die Kamera und tippen Sie auf die Schaltfläche.',
    'kiosk.photo.take': 'Mein Foto aufnehmen',
    'kiosk.photo.getReady': 'Bitte warten…',
    'kiosk.photo.retake': 'Noch einmal aufnehmen',
    'kiosk.photo.use': 'Dieses Foto verwenden',
    'kiosk.photo.skip': 'Foto überspringen',
    'kiosk.photo.failed': 'Das Foto hat nicht funktioniert. Bitte versuchen Sie es erneut.',
    'kiosk.photo.noCamera': 'Die Kamera ist nicht verfügbar. Sie können ohne Foto fortfahren.',
    'kiosk.photo.privacy': 'Ihr Foto wird nur für Ihren Ausweis und Ihren Besuchereintrag verwendet.',
    'kiosk.badge.title': 'Ihr Ausweis',
    'kiosk.badge.ask': 'Möchten Sie einen Ausweis?',
    'kiosk.badge.yes': 'Meinen Ausweis drucken',
    'kiosk.badge.no': 'Nein danke, kein Ausweis',
    'kiosk.badge.printing': 'Ihr Ausweis wird gedruckt…',
    'kiosk.badge.done': 'Bitte nehmen Sie Ihren Ausweis mit',
    'kiosk.badge.failed': 'Der Ausweis konnte leider nicht gedruckt werden. Sie sind angemeldet. Bitte fragen Sie an der Rezeption nach einem Ausweis.',
    'kiosk.signout.title': 'Finden Sie Ihren Namen zum Abmelden',
    'kiosk.signout.search': 'Nach Namen suchen',
    'kiosk.signout.hiddenHint': 'Aus Datenschutzgründen werden keine Namen angezeigt. Geben Sie Ihren Namen ein oder scannen Sie Ihren Ausweis.',
    'kiosk.signout.empty': 'Niemand ist angemeldet.',
    'kiosk.signout.noMatch': 'Niemand gefunden. Versuchen Sie es erneut oder scannen Sie Ihren Ausweis.',
    'kiosk.signout.unnamed': 'Besucher',
    'kiosk.scan.title': 'Scannen Sie Ihren Ausweis',
    'kiosk.scan.hint': 'Halten Sie den QR-Code auf Ihrem Ausweis vor die Kamera.',
    'kiosk.scan.allow': 'Kamera erlauben',
    'kiosk.scan.noCamera': 'Die Kamera ist nicht verfügbar. Bitte wählen Sie Ihren Namen aus der Liste.',
    'kiosk.scan.notBadge': 'Das ist kein CloudSign-Ausweis. Bitte versuchen Sie es erneut.',
    'kiosk.scan.notSignedIn': 'Dieser Ausweis ist hier nicht angemeldet. Bitte wählen Sie Ihren Namen aus der Liste.',
    'kiosk.finish.inTitle': 'Danke, {name}',
    'kiosk.finish.inMessage': 'Sie sind angemeldet.',
    'kiosk.finish.outTitle': 'Auf Wiedersehen, {name}',
    'kiosk.finish.outMessage': 'Sie sind abgemeldet. Gute Heimreise!',
    'kiosk.finish.tap': 'Zum Beenden tippen',
    'kiosk.update.title': 'Dieses Kiosk benötigt ein Update',
    'kiosk.update.message': 'Dieses Kiosk muss vor der Anmeldung aktualisiert werden. Bitte fragen Sie an der Rezeption nach.',
    'kiosk.update.short': 'Update erforderlich',
    'kiosk.error.required': 'Bitte beantworten Sie diese Frage.',
    'kiosk.error.mustAcknowledge': 'Bitte bestätigen Sie durch Anklicken.',
    'kiosk.error.nameRequired': 'Bitte geben Sie Ihren Namen ein.',
    'kiosk.error.fullName': 'Bitte geben Sie Ihren Vor- und Nachnamen an.',
    'kiosk.error.tooLong': 'Diese Antwort ist zu lang.',
    'kiosk.error.number': 'Bitte geben Sie eine Zahl ein.',
    'kiosk.error.wholeNumber': 'Bitte geben Sie eine ganze Zahl ein.',
    'kiosk.error.range': 'Diese Zahl liegt außerhalb des zulässigen Bereichs.',
    'kiosk.error.email': 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
    'kiosk.error.phone': 'Bitte geben Sie eine gültige Telefonnummer ein.',
    'kiosk.error.date': 'Bitte geben Sie ein Datum wie 2026-12-31 ein.',
    'kiosk.error.answerNotAllowed': 'Mit dieser Antwort können Sie sich hier nicht anmelden. Bitte wenden Sie sich an die Rezeption.',
    'kiosk.print.state.ready': 'Der Drucker ist bereit',
    'kiosk.print.state.no_media': 'Dem Drucker sind die Etiketten ausgegangen',
    'kiosk.print.state.cover_open': 'Die Abdeckung des Druckers ist offen',
    'kiosk.print.state.media_mismatch': 'Im Drucker sind die falschen Etiketten eingelegt',
    'kiosk.print.state.busy': 'Der Drucker ist beschäftigt',
    'kiosk.print.state.error': 'Der Drucker meldet ein Problem',
    'kiosk.print.state.unreachable': 'Der Drucker ist nicht erreichbar',
    'kiosk.print.state.unknown': 'Der Status des Druckers ist unbekannt',
    'kiosk.home.expected': 'Ich werde erwartet',
    'kiosk.home.scanCode': 'Meinen QR-Code scannen',
    'kiosk.scan.titleCode': 'Scannen Sie Ihren QR-Code',
    'kiosk.scan.hintCode': 'Halten Sie den QR-Code aus Ihrer E-Mail, Ihrer Karte oder Ihrem Ausweis vor die Kamera.',
    'kiosk.scan.invalid': 'Dieser QR-Code ist hier nicht gültig. Bitte versuchen Sie es erneut oder wählen Sie Ihren Namen aus der Liste.',
    'kiosk.scan.notSupported': 'Dieses Kiosk kann diese Art von QR-Code nicht verwenden. Bitte wählen Sie Ihren Namen aus der Liste.',
    'kiosk.scan.unknownMember': 'Dieser QR-Code ist an diesem Kiosk nicht bekannt. Bitte wählen Sie Ihren Namen aus der Liste.',
    'kiosk.scan.oldCode': 'Dieser QR-Code wurde durch einen neuen ersetzt. Bitte verwenden Sie den neuesten oder wählen Sie Ihren Namen.',
    'kiosk.scan.notHere': 'Dieser QR-Code gilt nicht für dieses Kiosk.',
    'kiosk.scan.notExpected': 'Wir erwarten diesen QR-Code heute nicht. Bitte fragen Sie an der Rezeption nach.',
    'kiosk.scan.cancelled': 'Dieser Besuch wurde abgesagt. Bitte fragen Sie an der Rezeption nach.',
    'kiosk.scan.alreadyArrived': 'Dieser QR-Code wurde bereits zur Anmeldung verwendet.',
    'kiosk.scan.expired': 'Dieser QR-Code ist abgelaufen. Bitte fragen Sie an der Rezeption nach.',
    'kiosk.expected.title': 'Wer sind Sie?',
    'kiosk.expected.search': 'Geben Sie Ihren Namen ein',
    'kiosk.expected.exactHint': 'Bitte geben Sie Ihren vollständigen Namen genau so ein, wie er uns mitgeteilt wurde.',
    'kiosk.expected.requiredHint': 'Sie müssen angekündigt sein, um sich hier anzumelden. Suchen Sie Ihren Namen oder scannen Sie Ihren QR-Code.',
    'kiosk.expected.none': 'Wir konnten diesen Namen auf der heutigen Liste nicht finden. Bitte fragen Sie an der Rezeption nach.',
    'kiosk.expected.empty': 'Im Moment wird niemand erwartet.',
    'kiosk.expected.visiting': 'Besuch bei {host}',
    'kiosk.expected.required': 'Sie müssen angekündigt sein, um sich hier anzumelden. Bitte fragen Sie an der Rezeption nach.',
    'kiosk.signout.outMark': 'Abgemeldet',
    'kiosk.signout.outToday': 'Heute abgemeldet',
    'kiosk.hostReply.on_my_way': '{host} ist unterwegs.',
    'kiosk.hostReply.please_wait': '{host} bittet Sie, kurz zu warten.',
    'kiosk.hostReply.someone': 'Ihre Kontaktperson',
    'kiosk.hostReply.dismiss': 'OK',
    'kiosk.evacuation.notAllowed': 'Von diesem Kiosk aus kann keine Evakuierung gestartet werden.',
    'kiosk.evacuation.wrongPin': 'Diese PIN ist nicht richtig.',
    'kiosk.evacuation.pinLocked': 'Zu viele falsche PINs. Bitte warten Sie einige Minuten.',
    'kiosk.evacuation.startFailed': 'Die Evakuierung konnte nicht gestartet werden. Bitte versuchen Sie es erneut.',
    'kiosk.nfc.enrolOffline': 'Dieses Kiosk ist offline. Karten können nur registriert werden, solange es online ist.',
    'kiosk.nfc.enrolExpired': 'Diese Kartenregistrierung ist beendet oder abgelaufen.',
    'kiosk.nfc.enrolFailed': 'Diese Karte konnte nicht registriert werden. Bitte versuchen Sie eine andere.',
    'kiosk.nfc.enrolTapAgain': 'Bitte halten Sie die Karte erneut an das Lesegerät.',
    'kiosk.common.ok': 'OK',
    'kiosk.welcome.stale': 'Dieses Kiosk war lange offline. Bitte informieren Sie die Rezeption.',
    'kiosk.welcome.busy': 'Am Standort ist im Moment viel los. Wenn Sie zu Besuch kommen, informieren Sie bitte die Rezeption.',
    'kiosk.welcome.evacuation': 'Evakuierung',
    'kiosk.home.delivery': 'Ich liefere ein Paket',
    'kiosk.check.seeReceptionTitle': 'Bitte wenden Sie sich an die Rezeption',
    'kiosk.check.warnTitle': 'Bitte beachten Sie vor dem Fortfahren',
    'kiosk.full.short': 'Der Standort ist voll',
    'kiosk.full.title': 'Der Standort ist voll',
    'kiosk.full.message': 'Wir können im Moment keine weiteren Besucher anmelden. Bitte wenden Sie sich an die Rezeption.',
    'kiosk.induction.subtitle': 'Sicherheitsunterweisung',
    'kiosk.induction.unavailable': 'Die Sicherheitsunterweisung ist an diesem Kiosk nicht verfügbar. Bitte wenden Sie sich an die Rezeption.',
    'kiosk.induction.videoMissing': 'Das Video ist noch nicht auf diesem Kiosk. Bitte lesen Sie den Text unten.',
    'kiosk.induction.pdfNote': 'Bitte lesen Sie den Unterweisungstext unten. Fragen Sie an der Rezeption nach, wenn Sie das Dokument möchten.',
    'kiosk.induction.wait': 'Bitte warten Sie {seconds} Sekunden',
    'kiosk.induction.startQuiz': 'Fragen starten',
    'kiosk.induction.question': 'Frage {n} von {total}',
    'kiosk.induction.chooseMany': 'Wählen Sie alle richtigen Antworten aus.',
    'kiosk.induction.finish': 'Fertig',
    'kiosk.induction.retryTitle': 'Noch nicht ganz',
    'kiosk.induction.retryMessage': 'Einige Antworten waren nicht richtig. Bitte versuchen Sie {count} erneut.',
    'kiosk.induction.retryButton': 'Erneut versuchen',
    'kiosk.permits.title': 'Ihre Arbeitserlaubnisse',
    'kiosk.permits.unavailable': 'Ihre Arbeitserlaubnisse können im Moment nicht angezeigt werden. Bitte wenden Sie sich vor Arbeitsbeginn an die Rezeption.',
    'kiosk.permits.allAccepted': 'Sie haben alle Ihre Arbeitserlaubnisse akzeptiert.',
    'kiosk.permits.progress': 'Erlaubnis {n} von {total}',
    'kiosk.permits.valid': 'Vom {from} bis {until}',
    'kiosk.permits.conditions': 'Bedingungen',
    'kiosk.permits.precautions': 'Vorsichtsmaßnahmen',
    'kiosk.permits.signHere': 'Unterschreiben Sie hier zur Annahme, {name}',
    'kiosk.permits.accept': 'Ich akzeptiere diese Erlaubnis',
    'kiosk.nfc.blocked': 'Diese Karte wurde gesperrt',
    'kiosk.nfc.unknown': 'Karte nicht erkannt',
    'kiosk.nfc.enrolTitle': 'Karten registrieren',
    'kiosk.nfc.enrolProgress': '{done} von {total} erledigt',
    'kiosk.nfc.enrolTapFor': 'Halten Sie die Karte an das Lesegerät für',
    'kiosk.nfc.enrolHold': 'Halten Sie die Karte an die Rückseite des Tablets.',
    'kiosk.nfc.enrolSaving': 'Wird gespeichert…',
    'kiosk.nfc.enrolOk': 'Karte gespeichert.',
    'kiosk.nfc.enrolDone': 'Alle Karten sind registriert',
    'kiosk.nfc.noReader': 'An diesem Kiosk ist kein Kartenleser eingeschaltet.',
    'kiosk.evacuation.title': 'EVAKUIERUNG',
    'kiosk.evacuation.drillTitle': 'BRANDSCHUTZÜBUNG',
    'kiosk.evacuation.startTitle': 'Evakuierung starten',
    'kiosk.evacuation.confirmTitle': 'Evakuierung starten?',
    'kiosk.evacuation.confirmMessage': 'Dies alarmiert alle Personen auf dem Gelände und öffnet die Anwesenheitsliste.',
    'kiosk.evacuation.confirmStart': 'Evakuierung starten',
    'kiosk.evacuation.leave': 'Anwesenheitsliste verlassen',
    'kiosk.evacuation.leaveTitle': 'Geben Sie die PIN ein, um die Anwesenheitsliste zu verlassen',
    'kiosk.evacuation.returnBanner': 'Evakuierung läuft. Tippen Sie, um zur Anwesenheitsliste zurückzukehren.',
    'kiosk.evacuation.offline': 'Offline: Ihre Markierungen werden gespeichert und gesendet, sobald das Netz wieder verfügbar ist.',
    'kiosk.evacuation.localOnly': 'Auf diesem Kiosk offline gestartet. Sie wird mit dem Portal zusammengeführt, sobald das Netz wieder verfügbar ist.',
    'kiosk.evacuation.countUnaccounted': 'Noch nicht gefunden',
    'kiosk.evacuation.countSafe': 'Sicher',
    'kiosk.evacuation.countMissing': 'Vermisst',
    'kiosk.evacuation.countTotal': 'Auf dem Gelände',
    'kiosk.evacuation.allPoints': 'Alle',
    'kiosk.evacuation.search': 'Nach Namen suchen',
    'kiosk.evacuation.onlyOpen': 'Noch nicht sicher',
    'kiosk.evacuation.loading': 'Anwesenheitsliste wird geladen…',
    'kiosk.evacuation.nobody': 'Niemand anzuzeigen.',
    'kiosk.evacuation.safe': 'Sicher',
    'kiosk.evacuation.markedSafe': 'SICHER (tippen zum Rückgängigmachen)',
    'kiosk.evacuation.missing': 'Vermisst',
    'kiosk.evacuation.markedMissing': 'VERMISST (tippen zum Rückgängigmachen)',
    'kiosk.evacuation.host': 'Ansprechpartner: {name}',
    'kiosk.evacuation.check': 'PRÜFEN',
    'kiosk.evacuation.permits': '{count} offene Erlaubnis(se)',
    'kiosk.contactless.qrLabel': 'Scannen Sie diesen Code mit Ihrem Telefon, um sich anzumelden',
    'kiosk.contactless.scanMe': 'Mit Ihrem Telefon anmelden',
    'kiosk.courier.whoTitle': 'Für wen ist das Paket?',
    'kiosk.courier.whoHint': 'Geben Sie ein paar Buchstaben des Namens ein.',
    'kiosk.courier.search': 'Name der Person',
    'kiosk.courier.useName': '„{name}“ verwenden',
    'kiosk.courier.useNameHint': 'Die Rezeption leitet es weiter',
    'kiosk.courier.carrierTitle': 'Von welchem Unternehmen kommen Sie?',
    'kiosk.courier.forName': 'Paket für {name}',
    'kiosk.courier.other': 'Andere',
    'kiosk.courier.otherLabel': 'Name des Unternehmens',
    'kiosk.courier.countTitle': 'Wie viele Pakete?',
    'kiosk.courier.howMany': 'Anzahl der Pakete',
    'kiosk.courier.save': 'Fertig',
    'kiosk.courier.thanks': 'Danke',
    'kiosk.courier.thanksMessage': 'Wir haben den Empfänger informiert, dass sein Paket da ist.',
    'kiosk.support.pinTitle': 'Support: PIN eingeben',
    'kiosk.support.title': 'Support',
    'kiosk.support.close': 'Schließen',
    'kiosk.support.network': 'Netzwerk',
    'kiosk.support.online': 'Online',
    'kiosk.support.offline': 'Offline',
    'kiosk.support.queue': 'Wartet auf Versand',
    'kiosk.support.oldest': 'Ältester wartet seit',
    'kiosk.support.none': 'Keine',
    'kiosk.support.deadLetters': 'Vom Server abgelehnt (nicht gesendet)',
    'kiosk.support.deadHelp': 'Diese Einträge wurden vom Server abgelehnt und bleiben auf diesem Kiosk. Informieren Sie Ihren Administrator; die Geräteseite im Portal zeigt die Anzahl an.',
    'kiosk.support.configAge': 'Einstellungen zuletzt aktualisiert',
    'kiosk.support.ageUnknown': 'Nie',
    'kiosk.support.ageMinutes': 'vor {n} Minuten',
    'kiosk.support.ageHours': 'vor {n} Stunden',
    'kiosk.support.ageDays': 'vor {n} Tagen',
    'kiosk.support.nfc': 'Kartenleser',
    'kiosk.support.nfcReady': 'Bereit',
    'kiosk.support.nfcOff': 'Ausgeschaltet',
    'kiosk.support.nfcNone': 'Nicht eingebaut',
    'kiosk.support.media': 'Gespeicherte Videos',
    'kiosk.support.mediaMb': '{mb} MB',
    'kiosk.support.headcount': 'Personen auf dem Gelände (dieses Kiosk)',
    'kiosk.finish.poweredBy': 'Bereitgestellt von CloudSign',
    'kiosk.badge.noMedia': 'Dem Ausweisdrucker sind die Etiketten ausgegangen. Sie sind angemeldet. Bitte informieren Sie die Rezeption.',
    'kiosk.badge.mediaMismatch': 'Im Ausweisdrucker sind die falschen Etiketten eingelegt. Sie sind angemeldet. Bitte informieren Sie die Rezeption.',
    'kiosk.badge.coverOpen': 'Die Abdeckung des Ausweisdruckers ist offen. Sie sind angemeldet. Bitte informieren Sie die Rezeption.',
    'kiosk.member.menuTitle': 'Was möchten Sie tun?',
    'kiosk.member.signIn': 'Mich anmelden',
    'kiosk.member.updatePhoto': 'Mein Foto aktualisieren',
    'kiosk.member.sendInvite': 'Mir die App-Einladung senden',
    'kiosk.memberPhoto.title': 'Ihr Foto aktualisieren',
    'kiosk.memberPhoto.saved': 'Ihr Foto wurde aktualisiert.',
    'kiosk.memberPhoto.failed': 'Ihr Foto konnte nicht gespeichert werden. Bitte versuchen Sie es erneut oder fragen Sie an der Rezeption nach.',
    'kiosk.memberPhoto.offline': 'Dieses Kiosk ist offline, daher kann Ihr Foto im Moment nicht aktualisiert werden.',
    'kiosk.memberPhoto.notAllowed': 'Ihr Foto kann am Kiosk nicht aktualisiert werden. Bitte fragen Sie an der Rezeption nach.',
    'kiosk.invite.title': 'Die CloudSign-App herunterladen',
    'kiosk.invite.sent': 'Wir haben Ihnen einen Link zur Einrichtung der App per E-Mail gesendet. Bitte prüfen Sie Ihren Posteingang.',
    'kiosk.invite.noEmail': 'Wir haben keine E-Mail-Adresse für Sie, daher konnten wir keine Einladung senden. Bitte fragen Sie an der Rezeption nach.',
    'kiosk.invite.tooMany': 'Sie haben heute zu viele Einladungen angefordert. Bitte versuchen Sie es morgen erneut.',
    'kiosk.invite.failed': 'Die Einladung konnte nicht gesendet werden. Bitte versuchen Sie es erneut oder fragen Sie an der Rezeption nach.',
    'kiosk.invite.offline': 'Dieses Kiosk ist offline, daher kann im Moment keine Einladung gesendet werden.',
    'kiosk.invite.sending': 'Ihre Einladung wird gesendet…',
    'kiosk.language.choose': 'Wählen Sie Ihre Sprache',
    'kiosk.language.button': 'Sprache',
    'public.language.label': 'Sprache',
    'contactless.thank_you': 'Danke. Sie sind angemeldet.',
    'contactless.thank_you_out': 'Danke. Sie sind abgemeldet.',
    'contactless.poster.title': 'Zum Anmelden scannen',
    'contactless.poster.hint': 'Richten Sie die Kamera Ihres Telefons auf den Code. Keine App nötig.',
    'check.safety_check.refused': 'Bitte wenden Sie sich vor der Anmeldung an die Rezeption.',
    'check.safety_check.alert': 'Mit einer Warnung an die Rezeption zugelassen (Sicherheitsprüfung).',
    'check.compliance.refused': 'Ein erforderliches Dokument fehlt oder ist abgelaufen. Bitte wenden Sie sich an die Rezeption.',
    'check.compliance.warned': 'Ein erforderliches Dokument fehlt oder ist abgelaufen.',
    'check.induction.required': 'Bitte absolvieren Sie zuerst die Sicherheitsunterweisung.',
    'check.capacity.full': 'Der Standort ist im Moment voll. Bitte wenden Sie sich an die Rezeption.',
    'check.capacity.warned': 'Angemeldet, während der Standort über seiner Kapazität war.',
    'check.offline': 'Aufgezeichnet, während das Kiosk offline war.',
};
//# sourceMappingURL=de.js.map